module.exports={
	"Form": "TestSpecificationRequirementEditManifest",
	"Scope": "TestSpecificationRequirement-Edit",
	"Descriptors":
	{
		"TestSpecificationRequirementDetails.Name":
		{
			"Name": "Name",
			"Hash": "TestSpecificationRequirement-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "TestSpecificationRequirement-Edit-Identity",
				"Group": "TestSpecificationRequirement-Edit-Identity"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecification":
		{
			"Name": "Test Specification",
			"Hash": "TestSpecificationRequirement-Edit-IDTestSpecification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details",
				"Entity": "TestSpecification",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.IDTest":
		{
			"Name": "Test",
			"Hash": "TestSpecificationRequirement-Edit-IDTest",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details",
				"Entity": "Test",
				"SearchFields":
				[
					"Name",
					"Description"
				]
			}
		},
		"TestSpecificationRequirementDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "TestSpecificationRequirement-Edit-Ordinal",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OperationType":
		{
			"Name": "Operation Type",
			"Hash": "TestSpecificationRequirement-Edit-OperationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMinimum":
		{
			"Name": "Value Minimum",
			"Hash": "TestSpecificationRequirement-Edit-ValueMinimum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ValueMaximum":
		{
			"Name": "Value Maximum",
			"Hash": "TestSpecificationRequirement-Edit-ValueMaximum",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationTemplate":
		{
			"Name": "Computation Template",
			"Hash": "TestSpecificationRequirement-Edit-ComputationTemplate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeType":
		{
			"Name": "Outcome Type",
			"Hash": "TestSpecificationRequirement-Edit-OutcomeType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.OutcomeTargets":
		{
			"Name": "Outcome Targets",
			"Hash": "TestSpecificationRequirement-Edit-OutcomeTargets",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationSuccessOutcome":
		{
			"Name": "Computation Success Outcome",
			"Hash": "TestSpecificationRequirement-Edit-ComputationSuccessOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.ComputationFailureOutcome":
		{
			"Name": "Computation Failure Outcome",
			"Hash": "TestSpecificationRequirement-Edit-ComputationFailureOutcome",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.PrecompiledSolver":
		{
			"Name": "Precompiled Solver",
			"Hash": "TestSpecificationRequirement-Edit-PrecompiledSolver",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "5",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-Details",
				"Group": "TestSpecificationRequirement-Edit-Details"
			}
		},
		"TestSpecificationRequirementDetails.IDTestSpecificationRequirement":
		{
			"Name": "IDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-Edit-IDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.GUIDTestSpecificationRequirement":
		{
			"Name": "GUIDTest Specification Requirement",
			"Hash": "TestSpecificationRequirement-Edit-GUIDTestSpecificationRequirement",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "TestSpecificationRequirement-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "TestSpecificationRequirement-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "TestSpecificationRequirement-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		},
		"TestSpecificationRequirementDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "TestSpecificationRequirement-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "TestSpecificationRequirement-Edit-DataAudit",
				"Group": "TestSpecificationRequirement-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "TestSpecificationRequirement-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "TestSpecificationRequirement-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "TestSpecificationRequirement-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "TestSpecificationRequirement-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "TestSpecificationRequirement-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "TestSpecificationRequirement-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
